import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { MotivosRechazo } from './motivosRechazo.model';

@Injectable()
export class MotivosRechazoResolver implements Resolve<MotivosRechazo> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(MotivosRechazo);
      }
      return await this.backendService.get(MotivosRechazo, MotivosRechazo.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/motivosRechazo']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/motivosRechazo/motivosRechazo.resolver.ts